export default __webpack_public_path__ + "static/media/codai.ecf52af0.svg";